import { fromSeconds } from '@/utils/timeFormat';
import { has, get } from '@/utils/lodash';
import { truncate } from '@/utils/text';

export default {
  install(Vue: any) {
    Vue.filter('fromSeconds', fromSeconds);
    Vue.filter('has', has);
    Vue.filter('get', get);
    Vue.filter('truncate', truncate);
  },
};
